import { render, staticRenderFns } from "./Divs.vue?vue&type=template&id=8d3854c6&"
import script from "./Divs.vue?vue&type=script&lang=js&"
export * from "./Divs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports